import React from 'react';
import { Loading } from '@carbon/react';
import { EnergyLinkErrorPage } from './energy-link-error-page';
import { useEnergyLinkAccess } from './useEnergyLinkAccess';

interface EnergyLinkAccessCheckProps {
  children: React.ReactNode;
}

export const EnergyLinkAccessCheck: React.FC<EnergyLinkAccessCheckProps> = ({
  children,
}) => {
  const { hasAccess, isLoading } = useEnergyLinkAccess();

  if (isLoading) {
    return <Loading small />;
  }

  if (hasAccess === false) {
    return <EnergyLinkErrorPage />;
  }

  return <>{children}</>;
};
